/**
 * PM portal · 验收标准 workflows assigned to the signed-in 项目经理. List → detail. Pricing and
 * (pre-release) the labor company's identity never reach this surface — stripped server-side.
 */
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getMe, pmListWorkflows, WF_STATUS, type MeResponse } from '../lib/api';
import { Skeleton } from '../components/ui/Skeleton';
import { EmptyState } from '../components/ui/EmptyState';

export default function PmStandards() {
  const { data: me } = useQuery<MeResponse>({ queryKey: ['me'], queryFn: getMe });
  const { data, isLoading } = useQuery({ queryKey: ['pm-workflows'], queryFn: pmListWorkflows, enabled: me?.account?.role === 'site_pm' });

  if (!me?.authenticated) return <div className="card">请先登录 / please log in.</div>;
  if (me.account?.role !== 'site_pm') return <div className="card">此页仅项目经理可见 / site-PM only.</div>;

  const items = data?.workflows ?? [];
  return (
    <div>
      <h2>验收标准 / Acceptance standards</h2>
      <p className="muted small">估价指派给您的项目会出现在这里：从标准库选定验收标准、回答劳务方问题、确认验收标准确认书。/ Projects assigned to you: pick standards from the library, answer the labor company's questions, confirm the annexure.</p>
      {isLoading && <div className="card"><Skeleton lines={3} /></div>}
      {!isLoading && items.length === 0 && (
        <EmptyState
          title="暂无指派 / Nothing assigned"
          hint={
            <>
              项目走完议价、最终价锁定后，由估价（预算部）在项目包的「验收标准」页签把项目指派给您，指派后才会出现在这里。
              <br />
              如果您的项目应该出现却没有，请联系估价确认两件事：① 该项目最终价是否已锁定并完成指派；② 指派时选的是否是您本人（企业微信登录）的那一行。
              <br />
              Your project appears here only after the final price locks and the estimator assigns it to you on the package's
              Standards tab. Missing a project? Ask the estimator to check the assignment — and that it targets your
              WeCom-login roster row.
            </>
          }
        />
      )}
      {items.map((w) => (
        <Link key={w.id} to={`/pm/standards/${w.id}`} style={{ color: 'inherit', textDecoration: 'none' }}>
          <div className="card" style={{ marginBottom: 8, cursor: 'pointer' }}>
            <div className="row-wrap" style={{ alignItems: 'center' }}>
              <strong>{w.project_name ?? w.package_name}</strong>
              <span className={`pill small ${WF_STATUS[w.status]?.pill}`}>{WF_STATUS[w.status]?.label}</span>
              <span className="spacer" />
              <span className="muted small">{w.updated_at.slice(0, 16).replace('T', ' ')}</span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
